const questions = [
    {
      id: 1,
      title: 'What is Shoonya?',
      info:
        "Shoonya is LEAD's most awaited flagship event. It is organized, keeping in mind both technical and non-technical skills development. The events in this are designed to test critical thinking skills, enrich competitive nature, and boost the participants' teamwork spirit.",
    },
    {
      id: 2,
      title: 'How can I participate in the events?',
      info:
        "You can register through the ‘Register’ option given under the 'Events' section to participate in any of the events.",
    },
    {
      id: 3,
      title: 'Is there any prior knowledge required?',
      info:
        'No prior knowledge is required to participate in any of the events. The events are constructed in a way that will help build logic and reasoning. Only willingness to think and learn is needed',
    },
    {
      id: 4,
      title: 'Do I need a team?',
      info:
        'It is not mandatory to have a team as all our events also have an option of individual participation. Maximum team size of all the events are mentioned in their respective rulebooks.',
    },
    {
      id: 5,
      title: 'Any other queries?',
      info:
        'If you have any other queries related to the event, you could drop a mail to us at Lead_sc@thapar.edu .We would be pleased to assist and clear your doubts.',
    },
  ]
  export default questions